<template>
  <v-layout>
    <div class="padding-container-sm">
			<div class="row my-4 justify-content-between">
				<div class="col-7">
					<b-input-group size="md">
						<b-input-group-text
							slot="append"
							class="bg-white"
						>
							<strong><i class="icon ion-md-search" /></strong>
						</b-input-group-text>
						<b-form-input
							class="border-right-0"
							:value="filter.searchValue"
							placeholder="Search for patient name or ID in Patient list"
							@keyup.enter.native="onSearchText"
							@blur.native="onSearchText"
						/>
					</b-input-group>
				</div>
				<div class="col col-3">
					<button
						type="button"
						class="btn btn-outline-primary btn-block"
            @click="addPatient"
					>
						<i class="icon ion-md-add" />
						Add Patient
					</button>
				</div>
			</div>
      <v-table
        :options="tableProps"
        :total-count="Number(totalCount)"
        :data="patientList"
        :isPatientSearched="isPatientSearched"
      >
        <template
          slot="patientName"
          slot-scope="slotProps"
        >
          <div class="align-items-center d-flex patient-name-content">
            <img
              :src="require(`@/assets/image/${slotProps.data.datum.gender === 'male'
                ? 'boy': 'girl'}.svg`)"
              width="35"
              height="35"
              :alt="slotProps.data.datum.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.first_name"
            >
            <div
              class="d-flex flex-column justify-content-center"
              v-if="slotProps"
            >
              <span
                class="text-center btn btn-link"
                @click="viewEHR(slotProps.data.datum.id)"
              >
                {{ slotProps.data.datum.first_name | capitalizefirst }}
                {{ slotProps.data.datum.last_name | capitalizefirst }}
              </span>
            </div>
          </div>
        </template>
        <template
          slot="userContact"
          slot-scope="slotProps"
        >
					<div>
					{{ slotProps.data && slotProps.data.datum.mobile_no |
						mobileformat(slotProps.data && slotProps.data.datum.country_code) }}
					</div>
					<div>
						{{ slotProps.data && slotProps.data.datum.email }}
					</div>
        </template>
				<template
					slot="actions"
          slot-scope="slotProps"
				>
					<button
						class="btn-modify"
						@click="addSymptoms(slotProps.data.datum.id)"
					>
						<i class="icon ion-md-add" />Add Symtoms
					</button>

				</template>

      </v-table>
    </div>
    <b-modal
      id="modal-center"
      ref="addSymptomsRef"
      body-class="pt-0"
      @hide="hideModal"
      centered
      title="Add Symptoms"
    >
      <div class="row px-4 mt-4">

        <div class="col-12 px-0 form-group">
          <b-form-group label-for="notes" label="Notes">
              <textarea
                maxlength="250"
                class="form-control"
                name="description"
                v-model="formData.description"
              />
          </b-form-group>
        </div>
        <div>
          <b-form-group
            label="Symptoms"
            label-for="symptoms-picker"
          >
           <span class="error-text text-left" v-if="!isEmpty(selectedAsssessments) && isSubmitted && !formData.description">Select atleast one field</span>
          </b-form-group>
        </div>
				<v-multi-select-table @selectedItems="getSelectedSymptoms" :actionType="`Add`">

				</v-multi-select-table>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="onValidateAndSubmit"
        >
          Add
        </b-btn>
        <b-btn
          size="sm"
          variant="outline-primary"
          class="float-right btn btn-outline-primary  mr-2"
          @click="hideModal"
        >
          Cancel
        </b-btn>
      </div>
    </b-modal>
    <v-loader :isLoading="isPatientsLoading" />
  </v-layout>
</template>

<script>
import VTable from '@/components/table/index.vue';
import { mapGetters } from 'vuex';
import VLayout from '@/layouts/Default.vue';
import VLoader from '@/components/loader/index.vue';
import VMultiSelectTable from '@/components/table/MultiSelect/index.vue'

const followUpData = {
  description: '',
  symptoms: [],
  symptoms_text: [],
  patient_id: ''
};

export default {
  name: 'PatientList',
  components: {
    VTable,
    VLayout,
		VLoader,
		VMultiSelectTable
  },
  data() {
    return {
      patient: {},
      formData: {},
      selectedAsssessments: [],
      isSubmitted: false,
      isPatientSearched: true,
      filter: {
        status: 'all',
        searchValue: '',
        limit: 10,
        pageNo: 1,
        isFirstResponder: true
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
              class: 'text-left'
            },
            cellSlot: {
              name: 'patientName'
            },
            dataKey: 'name',
            dataType: String,
            label: 'Name'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {},
            dataKey: 'mr_id',
            dataType: String,
            label: 'ID'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellSlot: {
              name: 'userContact'
            },
            cellProps: {},
            dataKey: 'user',
            dataType: String,
            label: 'Contact'
					},
					{
            headerCellProps: {
              class: 'header-cell'
            },
            cellSlot: {
              name: 'actions'
            },
            cellProps: {},
            label: 'Actions'
          },
        ],
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: 'PatientList'
      }
    };
  },
  computed: {
    ...mapGetters({
      patientList: 'patientList/getPatientList',
      loading: 'patientList/getLoading',
      totalCount: 'patientList/getTotalCount',
      permissions: 'auth/getModulePermissions',
      isPatientsLoading: 'patientList/getPatientListloading'
    })
  },
  beforeMount() {
    this.$store.dispatch('patientList/clearPatientList');
  },
  methods: {
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
      this.fetchPatients();
    },
    onSearchText(event) {
      if (event.target.value && event.target.value.trim()) {
        this.isPatientSearched = false;
        this.filter = {
          ...this.filter,
          pageNo:'1',
          searchValue: event.target.value
        };
        this.fetchPatients();
      }
    },
    fetchPatients() {
      this.$store.dispatch('patientList/getPatients', this.filter);
		},
		addSymptoms(id) {
      this.$store.dispatch('assessments/getAssessmentSymptoms');
      this.formData = {...followUpData};
      this.formData.patient_id = id;
      this.isSubmitted = false;
			this.$refs.addSymptomsRef.show();
		},

		onValidateAndSubmit() {
      this.isSubmitted = true;
			if ((this.selectedAsssessments && this.selectedAsssessments.length !== 0) || (this.formData.description && this.formData.description.trim() !== '')) {
        this.formData.symptoms = this.selectedAsssessments.map((symptom) => {
            return symptom.id
        });
        this.formData.symptoms_text = this.selectedAsssessments.map((symptom) => {
            return symptom.name
        });
        this.$store.dispatch('followUps/create', this.formData);
        this.$refs.addSymptomsRef.hide();
      }
    },
    hideModal() {
      this.$refs.addSymptomsRef.hide();
      this.formData = {...followUpData};
      this.selectedAsssessments = [];
    },
    getSelectedSymptoms(items) {
      this.selectedAsssessments = items;
    },
    addPatient() {
      this.$router.push({
        name: 'patient.create'
      })
    },
    viewEHR(id) {
      this.$router.push({
        name: 'patient.modify',
        params: {id: id}
      });
    },
  }
};
</script>
